import React from "react";

import SignUpForm from "./sign-up-form";
import SignInForm from "./sign-in-form";

const AuthenticationPage = () => {
  return (
    <div>
      <h1>Sign In Page</h1>
      <SignInForm />
      <SignUpForm />
    </div>
  );
};

export default AuthenticationPage;
